<div class="container min-vh-100">
    <div class="row min-vh-100 justify-content-center align-items-center">
        <div class="vid-card vid-card-padding vid-card-enrollment">
            <p class="section-title">{{ 'IDENTITY.HOME_WELCOME_MESSAGE' | translate }}</p>
            <button id="loginBtn" (click)="redirectService.redirectToSAMLLogin()" type="button"
                class="float-end vid-btn vid-btn-sm ms-2">{{ 'IDENTITY.LOGIN_BTN' | translate }}</button>
            <button id="enrollBtn" (click)="advanceToEnroll()" type="button"
                class="float-end vid-btn vid-btn-sm ms-2">{{ 'IDENTITY.ENROLL_BTN' | translate }}</button>
        </div>
    </div>
</div>
